import {motion} from 'framer-motion';
import {useDispatch} from 'react-redux';
import {closeModal} from '../../../../store/actions/modalActions';
import {deleteUser, getUsers} from '../../../../store/actions/userActions';
import styles from '../ModalDelete/ModalDelete.module.scss';
import Button from '../../../elements/Button/Button';
import {deleteUser as deleteUserAPI} from "../../../../services/user";
import toast from "react-hot-toast";
import {setErrors} from "../../../../store/actions/errorsActions";

const ModalDeleteUser = ({variants, data}) => {
    const dispatch = useDispatch();
    const {id, email} = data;

    const handleDelete = async () => {
        try {
            await deleteUserAPI(id);
            dispatch(deleteUser({id}));
            toast.success("User deleted successfully.");
            dispatch(getUsers());
        } catch (error) {
            console.error("Error deleting user:", error);
            dispatch(setErrors('user', error, "Failed to delete user."));
            toast.error("Failed to delete user.");
        }
        dispatch(closeModal());
        dispatch(getUsers());
    };

    return (
        <motion.div className={styles.container} variants={variants}>
            <h2>Confirm User Deletion</h2>
            <p className={styles.modalText}>
                Are you sure you want to delete the user with email: {email}? This action cannot be undone.
            </p>
            <div className={styles.ctaGroup}>
                <Button type="button" className="tertiary" onClick={() => dispatch(closeModal())}>
                    Cancel
                </Button>
                <Button type="button" className="delete" onClick={handleDelete}>
                    Delete
                </Button>
            </div>
        </motion.div>
    );
};

export default ModalDeleteUser;
